(function(global) {
	'use strict';
	
	/* アイソカル - HOME script.js */
	
	document.addEventListener('DOMContentLoaded', function() {
		ISCL.onLoaded([
			topKeyvisual
		]);
	}, false);
	window.addEventListener('resize', function() {
		ISCL.onResize(null);
	}, false);
	
	/**
	 * Web Font Loader
	 -------------------------------------------------- */
	function topKeyvisual() {
		if (document.querySelector('.keyvisual .o-slider') !== null) kv.constructor();
	}
	const kv = {
		constructor: function() {
			this.elm = document.querySelector('.keyvisual .o-slider');
			if (Flickity) this.setupSlider();
			ISCL.setupYouTube();
		},
		setupSlider: function() {
			this.slider = new Flickity(kv.elm, {
				contain: true,
				wrapAround: true,
				lazyLoad: true,
				autoPlay: 6000,
				pauseAutoPlayOnHover: false,
				arrowShape: 'M100,50a50,50,0,1,0-50,50A50,50,0,0,0,100,50ZM40.833,50,64.787,67.413a3.873,3.873,0,0,1,.854,5.412,3.887,3.887,0,0,1-3.135,1.593,3.84,3.84,0,0,1-2.275-.74L27.657,50,60.232,26.321a3.873,3.873,0,0,1,4.555,6.266Z',
				on: { settle: kv.onSettle }
			});
		},
		onSettle: function(index) {
			if (Flickity.data(kv.elm).player.state !== 'playing') {
				kv.slider.playPlayer();	
			}
		}
	};
	
})((this || 0).self || global);


$('.js-modalTrigger').on('click', function() {
  $('.l-modal').toggleClass('is-active');
});
